export const SUBSCRIBE = {
  LIST_ID: '7dd574156f',
  TAG: 'mycrypto.com',
};
